import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { Tooltip } from "react-tooltip";
import Link from "next/link";
import Image from "next/image";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import DropVoteProgressing from "@/components/drops/view/utils/DropVoteProgressing";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import { WAVE_VOTING_LABELS, WAVE_VOTE_STATS_LABELS } from "@/helpers/waves/waves.constants";
interface WaveLeaderboardDropRatersProps {
  readonly drop: ExtendedDrop;
}
export const WaveLeaderboardDropRaters: React.FC<WaveLeaderboardDropRatersProps> = t0 => {
  const $ = _c(43);
  const {
    drop
  } = t0;
  const votersCountLabel = drop.raters_count === 1 ? "voter" : "voters";
  const totalVote = drop.rating;
  const userVote = drop.context_profile_context?.rating ?? 0;
  const votingLabel = WAVE_VOTING_LABELS[drop.wave.voting_credit_type];
  const totalVoteClass = totalVote < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  const userVoteClass = userVote < 0 ? "tw-text-rose-400" : "tw-text-iron-50";
  const hasUserVoted = userVote !== 0;
  const t1 = `tw-font-medium ${totalVoteClass}`;
  let t2;
  if ($[0] !== totalVote) {
    t2 = formatNumberWithCommas(totalVote);
    $[0] = totalVote;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <span className={t1}>{t2}</span>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== drop.rating || $[6] !== drop.rating_prediction) {
    t4 = <DropVoteProgressing current={drop.rating} projected={drop.rating_prediction} compact={true} />;
    $[5] = drop.rating;
    $[6] = drop.rating_prediction;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = <div className="tw-relative tw-inline-flex tw-items-center tw-gap-x-1.5">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== votingLabel) {
    t6 = <span className="tw-whitespace-nowrap tw-font-normal tw-text-iron-400">{votingLabel} {WAVE_VOTE_STATS_LABELS.TOTAL}</span>;
    $[11] = votingLabel;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-sm tw-leading-5">{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== drop.id || $[17] !== drop.top_raters || $[18] !== votingLabel) {
    let t9;
    if ($[20] !== drop.id || $[21] !== drop.top_raters.length || $[22] !== votingLabel) {
      t9 = (voter, index) => {
        const voterLabel = voter.profile.handle ?? voter.profile.primary_address;
        const tooltipId = `voter-${drop.id}-${voter.profile.id}`;
        return <React.Fragment key={voter.profile.id}><div className="tw-relative tw-transition-transform hover:tw-z-10 hover:tw-scale-110" style={{
            zIndex: drop.top_raters.length - index
          }} data-tooltip-id={tooltipId}><Link href={`/${voterLabel}`}>{voter.profile.pfp ? <Image src={getScaledImageUri(voter.profile.pfp, ImageScale.W_AUTO_H_50)} alt={`${voterLabel}'s Profile`} width={20} height={20} className="tw-h-5 tw-w-5 tw-rounded-md tw-bg-iron-800 tw-object-contain tw-ring-1 tw-ring-black" /> : <div className="tw-h-5 tw-w-5 tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-black" />}</Link></div><Tooltip id={tooltipId} place="top" offset={8} opacity={1} positionStrategy="fixed" delayShow={0} style={TOOLTIP_STYLES}>{voterLabel} • {formatNumberWithCommas(voter.rating)}{" "}{votingLabel}</Tooltip></React.Fragment>;
      };
      $[20] = drop.id;
      $[21] = drop.top_raters.length;
      $[22] = votingLabel;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    t8 = drop.top_raters.map(t9);
    $[16] = drop.id;
    $[17] = drop.top_raters;
    $[18] = votingLabel;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[24] !== t8) {
    t9 = <div className="tw-flex tw-items-center -tw-space-x-1.5">{t8}</div>;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== drop.raters_count) {
    t10 = formatNumberWithCommas(drop.raters_count);
    $[26] = drop.raters_count;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== votersCountLabel) {
    t11 = <span className="tw-text-iron-400">{t10} {votersCountLabel}</span>;
    $[28] = t10;
    $[29] = votersCountLabel;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t11 || $[32] !== t9) {
    t12 = <div className="tw-flex tw-items-center tw-gap-2 tw-whitespace-nowrap tw-text-sm tw-leading-5">{t9}{t11}</div>;
    $[31] = t11;
    $[32] = t9;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== hasUserVoted || $[35] !== userVote || $[36] !== userVoteClass || $[37] !== votingLabel) {
    t13 = hasUserVoted && <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-leading-5"><span className="tw-whitespace-nowrap"><span className="tw-font-normal tw-text-iron-400">{WAVE_VOTE_STATS_LABELS.YOUR_VOTES}:{" "}</span><span className={`tw-font-medium ${userVoteClass}`}>{formatNumberWithCommas(userVote)} {votingLabel}</span></span></div>;
    $[34] = hasUserVoted;
    $[35] = userVote;
    $[36] = userVoteClass;
    $[37] = votingLabel;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t12 || $[40] !== t13 || $[41] !== t7) {
    t14 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2 sm:tw-justify-end">{t7}{t12}{t13}</div>;
    $[39] = t12;
    $[40] = t13;
    $[41] = t7;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  return t14;
};